import { EditableContent } from './EditableContent';

export default EditableContent;
